import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { interval, startWith, Subscription, switchMap, takeWhile } from 'rxjs';
import { Order, OrderStatus, PaymentStatuses } from '../../../../models/order.model';
import { ReportType } from '../../../../models/report.model';
import { ReportService } from '../../../reports/services/report.service';
import { OrderService } from '../../services/order.service';

@Component({
  selector: 'app-order-payment-status',
  templateUrl: './order-payment-status.component.html',
  styleUrls: ['./order-payment-status.component.scss'],
})
export class OrderPaymentStatusComponent implements OnInit, OnDestroy {
  public order: Order | undefined;
  public isMale: boolean = false;
  public reportId: string = '';
  public orderId: string = '';
  public hasPaymentError = false;
  private _subscription!: Subscription;

  public get isPaymentFailed(): boolean {
    return (
      this.hasPaymentError ||
      this.order?.payment.status === PaymentStatuses.FAILED ||
      this.order?.payment.status === PaymentStatuses.CANCELED
    );
  }

  public get isPaymentCompleted(): boolean {
    return this.order?.payment.status === PaymentStatuses.COMPLETED;
  }

  public get isPaymentProcessing(): boolean {
    return !this.isPaymentFailed && !this.isPaymentCompleted;
  }


  constructor(
    private _orderService: OrderService,
    private _reportService: ReportService,
    private _route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    this.orderId = this._route.snapshot.params['id'];
    const params = this._route.snapshot.queryParamMap;
    this.hasPaymentError = params.has('error') || params.has('failure');
    if (isPlatformBrowser(this.platformId)) {
      this._getOrder();
    }
  }

  ngOnDestroy() {
    this._unsubscribe();
  }

  public downloadReportInPdf() {
    if (isPlatformBrowser(this.platformId)) {
      this._reportService.getReport(this.reportId).subscribe((data) => {
        const report = data.data;

        if (report.type === ReportType.PRIMARY) {
          this._reportService.getPrimaryReportPDF(report, this.reportId);
        } else if (report.type === ReportType.EXTENDED) {
          this._reportService.getExtendedReportPDF(report, this.reportId);
        }
      });
    }
  }

  private _getOrder() {
    this._subscription = interval(3000)
      .pipe(
        startWith(0),
        switchMap(() => this._orderService.getOrder(this.orderId)),
        takeWhile((response) => {
          const status = response.data.status;

          return ![
            OrderStatus.COMPLETED,
            OrderStatus.FAILED,
            OrderStatus.CANCELED,
          ].includes(status);
        }, true),
      )
      .subscribe((response) => {
        this.order = response.data;
        this.reportId = response.data.report.token;
        this.isMale =
          this._orderService.getSexFromPesel(
            response.data.deceased.peselNumber,
          ) === 'male';

        if (
          [
            OrderStatus.COMPLETED,
            OrderStatus.FAILED,
            OrderStatus.CANCELED,
          ].includes(this.order.status)
        ) {
          this._unsubscribe();
        }
      });
  }

  public shortenPaymentId(value?: string): string {

    if (!value || value.length <= 10) {

      return value || '';

    }

    return `${value.slice(0, 6)}...${value.slice(-5)}`;

  }

  // private _getOrder() {
  //   this._subscription = interval(1000)
  //     .pipe(
  //       startWith(0),
  //       switchMap(() => this._orderService.getOrder(this.orderId)),
  //       takeWhile(
  //         (response) => response.data.status !== OrderStatus.COMPLETED,
  //         true,
  //       ),
  //     )
  //     .subscribe((response) => {
  //       this.order = response.data;
  //       this.reportId = response.data.report.token;
  //       this.isMale =
  //         this._orderService.getSexFromPesel(
  //           response.data.deceased.peselNumber,
  //         ) === 'male';
  //
  //       if (this.order.status === OrderStatus.COMPLETED) {
  //         this._unsubscribe();
  //       }
  //     });
  //
  //   this._orderService.getOrder(this.orderId).subscribe((data) => {
  //     this.order = data.data;
  //     this.reportId = data.data.report.token;
  //     this.isMale =
  //       this._orderService.getSexFromPesel(data.data.deceased.peselNumber) ===
  //       'male';
  //   });
  // }

  private _unsubscribe() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }
}
